import {Injectable} from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: "root"
})

export class LoaderService {
  isLoading = new Subject<boolean>();
  isInfiniteScrollLoading = new BehaviorSubject<boolean>(false);
  loaderExcludeUrl = new Subject<any>();
}